import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import store from '@/services/store'

Vue.use(Vuex)

export const HTTP = axios.create({
    baseURL: process.env.VUE_APP_API + '/api/v1',
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	}
})

// HTTP.interceptors.response.use(async(response) => {
//     return response
// }, () => {
//     store.dispatch('logout').then(() => {
//         window.location.href = '/login'
//     })
// })

HTTP.interceptors.request.use(async(config) => {
	if (isAccessTokenExpired()) {
		await refreshToken()
		.then(response => {
			store.dispatch('setAuth', response.data)
		})
		.catch(() => {
			store.dispatch('logout').then(() => {
				window.location.href = '/login'
			})
		})
	}
	if (store.state.auth.access_token) {
		config.headers.Authorization = 'Bearer ' + store.state.auth.access_token
	}
	return config
})

function isAccessTokenExpired () {
	return Math.round(Date.now() / 1000) > store.state.auth.expires_at
}

function refreshToken () {
	return axios.post(process.env.VUE_APP_API + '/oauth/token', {
		'grant_type': 'refresh_token',
		'client_id': process.env.VUE_APP_CLIENT_ID,
		'client_secret': process.env.VUE_APP_CLIENT_KEY,
		'refresh_token': store.state.auth.refresh_token
	})
}
